<template>
  <div id="app">
    <div class="index-bg" id="blend-in" @mouseover="hover = true"
         @mouseleave="hover = false"
         :style="{'background-image': 'url(' + image + ')'}" style="opacity: 1;">
      <div class="smiley" :class="{case : hover, incase : hoverto} " :style="{'background-image': 'url(' + image2 + ')'}" style="opacity: 1"></div>
      <bb-topheader></bb-topheader>
      <bb-header></bb-header>
      <div class="container">
        <div class="slide-caption" @mouseover="hoverto = true"
             @mouseleave="hoverto = false">
          <div :style="color"> {{caption}} </div> </div>
        <bb-searchbar></bb-searchbar>
      </div>


    </div>
    <router-view/>
    <div class="e-bulten p-2 p-md-5 mt-4">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 hucre">
            <div class="news-title">
              <h5>E-Bülten Üyeliği</h5>
            </div>
            <div v-if="newsletterTrue">
              <p class="mb-0">E-Bülten aboneliğimize üye olduğunuz için teşekkürler. Biletbul'un sunduğu özel kampanyaları sizinle paylaşmaktan mutluluk duyarız... </p>
            </div>
            <div v-else>
              <p class="mb-0">Üyelerimize özel avantajlardan faydalanmak, promosyonlu biletlerden herkesten once haberdar olmak için e-bülten listemize kayıt olun.</p>
              <div class="row">
                <div class="col-6 col-md-3 pr-md-0">
                  <mdb-input type="text" label="Adınız" outline v-model="subscrimeName"/>
                </div>
                <div class="col-6 col-md-3 pr-md-0">
                  <mdb-input type="text" label="Soyadınız" outline v-model="subscrimeSurName" />
                </div>
                <div class="col-12 col-md-4">
                  <mdb-input type="text" label="E-posta Adresiniz" outline v-model="subscrimeEmail" />
                </div>
                <div class="col-12 col-md-2 m-auto p-md-0">
                  <mdb-btn color="indigo btn-kamp-lightblue" class="btn-mobile-block ml-0"  @click="newsletter">Abone Ol</mdb-btn>
                </div>
                <p class="small text-center col-12">
                  Düzenli mail gönderimlerimiz haftada en fazla 2 gönderim yapılacaktır.
                  İstediğiniz zaman zarfında e-bülten üyeliğimizden hemen ayrılabilir ve arzu ederseniz de tekrar kayıt olabilirsiniz.
                </p>
                <div class="col-12 text-center">
                  <mdb-btn @click.native="ebultenmodal = true" color="indigo btn-red">E-bülten sözleşmesi</mdb-btn>

                </div>

              </div>
            </div>
          </div>
          <mdb-modal :show="ebultenmodal" @close="ebultenmodal = false" class="text-black">
            <mdb-modal-header>
              <mdb-modal-title>E-Bülten Sözleşmesi</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body ><div class="text-left" v-html="newsletter_agreement"></div></mdb-modal-body>
            <mdb-modal-footer>
              <mdb-btn color="blue" class="" @click.native="ebultenmodal = false">Kapat</mdb-btn>
            </mdb-modal-footer>
          </mdb-modal>
        </div>

      </div>
    </div>
    <bb-footer></bb-footer>
  </div>
</template>

<script>
  import topheader from '@/components/topheader'
  import searchBar from '@/components/searchBar';
  import header from '@/components/header'
  import bbfooter from '@/components/bbfooter'
  import { mdbStretchedLink,mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter,mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption } from 'mdbvue';
  import axios from "axios";

export default {
  name: 'App',
    components:{
      mdbContainer,
      mdbCol,
      mdbRow,
      mdbIcon,
      mdbTabs,
      mdbJumbotron,
      mdbView,
      mdbMask,
      mdbBtn,
      mdbTextarea,
      mdbInput,
      mdbCarouselItem,
      mdbCard,
      mdbCardImage,
      mdbCardBody,
      mdbCardTitle,
      mdbCardText,
      mdbCarousel,
      mdbCarouselCaption,mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter,mdbStretchedLink,
      'bb-topheader':topheader,
      'bb-header':header,
        'bb-footer':bbfooter,
      'bb-searchbar':searchBar,
    },
  data: () => ({
    newsletterTrue:false,
    subscrimeEmail:"",
    subscrimeSurName:"",
    subscrimeName:"",
    ebultenmodal:false,
    hover:false,
    hoverto:false,
    overflow:false,
    newsletter_agreement : "",
      images: [
        {
          text:"Dilediğin yere...",
          src: require('./assets/images/Layer-5.webp'),
          src2: require('./assets/images/download-3.webp'),
          style:'opacity:1',
          color: "color:white;padding-top:0;transform: translate(0, 0);\n" +
                  "transition: all 1s;opacity:1"
        },
        {
          text: "İstediğin Zaman",
          src: require('./assets/images/Slider_2.webp'),
          style:'opacity:1',
          color: "color:white;padding-top:1px;transform: translate(0, 0.1vh);\n" +
                  "transition: all 1s;opacity:1"
        },
        {
          text: "Avantajlı Uç",
          src: require('./assets/images/Layer-7.webp'),
          src2: require('./assets/images/Layer-0.webp'),
          style:'opacity:1',
          color: "color:#132a77;padding-top:0px;transform: translate(0, 0vh);\n" +
                  "transition: all 1s;opacity:1"
        }
      ],
      image: window.innerWidth>768?require('./assets/images/Layer-5.webp'):'',
      image2: window.innerWidth>768?require('./assets/images/download-3.webp'):'',
      caption: window.innerWidth>768?"Dilediğin yere...":'',
      style:'opacity:1',
      color: "color:white;padding-top:0;transform: translate(0, 0vh);\n" +
              "transition: all 1s;opacity:1",

  }),

  methods:{

    newsletter(){
      axios.post("https://www.biletbul.com/backend/public/api/v1/newsletter_subscriber",{
        name:this.subscrimeName,
        surname:this.subscrimeSurName,
        email:this.subscrimeEmail
      })
              .then((response) => {
                if(response.data.status == true){
                  response.data.data;
                  this.newsletterTrue = true;
                }
              });
    },
    getImage(){
      let i = 0
      let self = this

      setInterval(function() {
        self.image = self.images[i].src
        self.image2 = self.images[i].src2
        self.caption = self.images[i].text
        self.color = self.images[i].color

        i = i + 1;
        if (i == self.images.length) {
          i =  0;
        }
      }, 10000);
    }
  },

  mounted() {
    if(window.innerWidth>768){
      this.getImage()
    }
  }
}
</script>

<style>
#app {
}
</style>
